<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      <div style="display: flex;align-items: center" class="teachTitleList">
        <div
          v-for="(nav, index) in teachTitleList"
          :key="index"
        >
          <span v-if="userRole !=='coach' && index===0" style="display: none"></span>
          <span v-else class="nav_item" style="cursor: pointer;padding:10px 20px;" :class="idx === index ? 'active':''"      @click="changeNav(index)">{{nav}}</span>
          
        </div>
      </div>
    </template>
    <template v-slot:nav_right>
      <template v-if="userRole ==='coach'">
        <div v-if="selectVal.squadUuid" class="yioks_btn" @click="addPlan"> 添加比赛报告</div>
        <div v-else class="yioks_btn"  style="background-color: gray;cursor: not-allowed"> 添加比赛报告</div>
      </template>
    </template>
    <template v-slot:content_right>
      <div class="select_wrap"  style="padding: 20px 40px 0 40px"  v-if="userRole !== 'player'">
        <div class="select_box">
          <select v-model="selectVal.organUuid" class="yioks_select" @change="changeOrg">
            <option value="" v-if="organList.length !== 1">全部区体育行政部门</option>
            <option
              v-for="item in organList"
              :key="item.organUuid"
              :value="item.organUuid">{{item.organShortName}}
            </option>
          </select>
          <select v-model="selectVal.youthUuid" class="yioks_select" @change="changeCenter">
            <option value="" v-if="centerList.length !== 1">全部培训机构</option>
            <option
              v-for="item in centerList"
              :key="item.uuid"
              :value="item.uuid">{{item.youthShortName}}
            </option>
          </select>
          <select
            v-model="selectVal.squadUuid"
            class="yioks_select"
            @change="changeSquad"
          >
            <option value="" v-if="squadList.length !== 1" >全部球队</option>
            <option v-for="item in squadList" :key="item.uuid" :value="item.uuid">{{item.shortName}}</option>
          </select>
        </div>
        <div class="search_box">
          <input
            v-model.trim="selectVal.seacherString"
            type="text"
            class="yioks_input"
            style="width: 200px"
            placeholder="请输入关键字"
            @keyup.enter="changeQuery(true)">
          <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
        </div>
      </div>
      <div class="mainTeachingContent">
        <yioks-loading v-if="loading"></yioks-loading>
        <template v-else>
          <yioks-empty v-if="empty"></yioks-empty>
            <div v-else class="list_wrap" >
              <div  class="table">
                <div class="thead">
                  <div class="tr">
                    <div class="th name"><strong>比赛报告</strong></div>
                    <div class="th youth"><strong>所属青训中心</strong></div>
                    <div class="th org"><strong>所属球队</strong></div>
                    <div class="th coachName"><strong>主教练</strong></div>
                    <div class="th start"><strong>开始时间</strong></div>
                    <div class="th opt"><strong>操作</strong></div>
                  </div>
                </div>
                <vue-scroll >
                <div class="scrollArea">
                    <div class="tbodyWrap">
                      <div class="tbody">
                        <div
                          v-for="(item, index) in teachingList"
                          :key="index"
                          class="t_content"
                          >
                          <div class="tr">
                            <div class="td name">
                              <p>{{ item.trainingName || '--' }}</p>
                            </div>
                            <div class="td youth">
                              <p>{{ item.youthShortName || '--' }}</p>
                            </div>
                            <div class="td org">
                              <p>{{ item.squadName || '--' }}</p>
                            </div>
                            <div class="td coachName">
                              <p>{{item.chiefCoachName}}</p>
                            </div>
                            <div class="td start">
                              <p>{{item.trainingTime | time}}</p>
                            </div>
                            <div class="td opt">
                              <p v-if="idx === 0">
                                <span v-if="userRole === 'coach'" class="item"  @click="edit(item.uuid)"  >编辑报告</span>
                                <span v-else  >--</span>
                              </p>
                              <p v-else>
                                <span class="item"  @click="goPlanDetail(item.uuid)">查看报告</span>
                                <template v-if="userRole !=='player'">
                                  <span style="margin: 0 5px"> / </span>
                                  <span class="item" @click="download(item.uuid)" >下载报告</span>
                                </template>
                              </p>
                            </div>
                          </div>
                          <div class="bottom" @click="goDetail(item.editorTacticalUuid)">
                            <div style="text-align: center;margin-top: 10px">比赛记录</div>
                            <div class="intro">
                              <div class="team">
                                <div class="teamPlace">(主场)</div>
                                <div class="teamName">{{item.teamWePlay === 'Home'? item.teamNameOurs : item.teamNameOpposition}}</div>
                              </div>
                              <div class="compete">
                                vs
                              </div>
                              <div class="team">
                                <div class="teamName">{{item.teamWePlay === 'Home'? item.teamNameOpposition : item.teamNameOurs}}</div>
                                <div class="teamPlace">(客场)</div>
                              </div>
                            </div>
                            <div class="matchType">
                              <span class="left_triangle"></span>
                              <span class="left">{{item.categoryZh}}</span>
                              <span class="right">{{item.skillLevelZh}}</span>
                              <span class="right_triangle"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
                </vue-scroll>
              </div>
            </div>
        </template>
      </div>
      <Pagination v-if="teachingList.length > 0" :total="total" :page.sync="page"/>
    </template>
  </SubContent>
</template>

<script>
import storage from '@/utils/storage'
// import coach from '@/api/coach'
import squad from '@/api/squad'
import teaching from '@/api/teaching'
import common from '@/api/common'
export default {
  name: 'index',
  components: {
    'SubContent': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination')
  },
  data () {
    return {
      teachTitleList: ['编写中比赛报告', '已完成比赛报告'],
      selectVal: {
        seacherString: this.$route.query.key || '',
        youthUuid: this.$route.query.youthUuid || '',
        organUuid: this.$route.query.organUuid || '',
        squadUuid: this.$route.query.squadUuid || '',
        squadId: ''
      },
      centerList: [],
      squadList: [],
      squadName: this.$route.query.squadName || '',
      organList: [],
      uuid: storage.get('userInfo').uuid,
      userRole: storage.get('userInfo').userRole,
      page: 0,
      total: 0,
      pageSize: 20,
      loading: true,
      empty: false,
      teachingList: [],
      idx: Number(this.$route.query.idx) || 0,
      downIng: false
    }
  },
  watch: {
    page () {
      this.changeQuery()
    }
  },
  created () {
    const { idx } = this.$route.query
    let id
    if (this.userRole !== 'coach') {
      id = 1
    } else {
      id = 0
    }
    this.idx = idx ? Number(idx) : id
    if (this.userRole === 'player'){
      this.getTeachingList()
    } else{
      this.getCenterList()
    }

  },
  methods: {
    changeSquad () {
      if (this.selectVal.squadUuid) {
        this.squadName = this.squadList.find(item => {
          return item.uuid === this.selectVal.squadUuid
        }).shortName
        this.changeQuery(true)
      }

    },
    changeNav (index) {
      if (this.idx === index) return
      this.idx = index
      this.changeQuery(true)
    },
    goDetail (uuid) {
      this.$router.push({
        path: 'detail',
        query: {
          uuid
        }
      })
    },
    goPlanDetail (uuid) {
      this.$router.push({
        path: 'planDetail',
        query: {
          uuid
        }
      })
    },
    download (uuid) {
      if (this.downIng) return
      this.downIng = true
      teaching.matchTrainingPlanDownLoadPdf({ trainingPlanUuid: uuid }).then(res => {
        const { fileName, filePath } = res
          const transferPath = this.$yioksConfig.transferBaseOnly(filePath)
          common.downfile(transferPath, fileName);
        this.downIng = false
      }).catch(err => {
        this.downIng = false
      })
    },
    edit (uuid) {
      this.$router.push({
        path: 'editTeaching',
        query: {
          uuid
        }
      })
    },
    getCenterList () {
      let data = this.uuid
      let request
      if (this.userRole === 'organ') {
        request = squad.getOrgListByOrgan
      } else if (this.userRole === 'system' || this.userRole === 'admin') {
        request = squad.getOrgListBySystem
        data = ''
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = squad.getOrgListByYouth
      } else if (this.userRole === 'leader' || this.userRole === 'coach') {
        request = squad.getOrgListByCoachOrLeader
      }
      request(data).then((res) => {
        this.organList = res
        if (this.selectVal.organUuid) {
          this.centerList = this.organList.find(item => {
            return item.organUuid === this.selectVal.organUuid
          }).youthList || []
          if (this.selectVal.squadUuid) {
            this.squadList = this.centerList.find(item => {
              return item.uuid === this.selectVal.youthUuid
            }).squadList || []
          }
        } else {
          if (this.organList.length === 1) {
            this.selectVal.organUuid = this.organList[0].organUuid
            this.centerList = this.organList[0].youthList || []
          }
        }
        if (this.centerList.length === 1) {
          if (!this.selectVal.youthUuid) {
            this.selectVal.youthUuid = this.centerList[0].uuid
          }
          this.squadList = this.centerList.find(item => {
            return item.uuid === this.selectVal.youthUuid
          }).squadList || []
          if (this.squadList.length === 1) {
            this.$set(this.selectVal, 'squadUuid', this.squadList[0].uuid)
            this.$set(this.selectVal, 'squadId', this.squadList[0].id)
            this.squadName = this.squadList[0].shortName
          }
        }
        this.getTeachingList()
      })
    },
    getTeachingList () {
      let request
      if (this.userRole === 'system' || this.userRole === 'admin') {
        request = teaching.getMatchTrainListSystem
      } else if (this.userRole === 'organ') {
        request = teaching.getMatchTrainListOrgan
      } else if (this.userRole === 'player') {
        request = teaching.getMatchTrainListPlayer
      } else if (this.userRole === 'youth' || this.userRole === 'trainCamp' || this.userRole === 'club') {
        request = teaching.getMatchTrainListYouth
      } else if (this.userRole === 'coach' || this.userRole === 'leader') {
        request = teaching.getMatchTrainListCoach
      }
      this.loading = true
      request({ page: this.page, size: this.pageSize, key: this.selectVal.seacherString, organUuid: this.selectVal.organUuid, youthUuid: this.selectVal.youthUuid, squadUuid: this.selectVal.squadUuid, status: this.idx === 0 ? 'INCOMPLETE' : 'COMPLETE' }).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
        } else {
          this.empty = false
          this.total = res.totalElements
          this.teachingList = res.content
        }
      }).catch(err => {
        this.loading = false
      })
    },
    changeQuery (flag) {
      if (flag) this.page = 0
      this.$router.replace({
        path: this.$route.path,
        query: {
          page: this.page,
          key: this.selectVal.seacherString,
          idx: this.idx,
          youthUuid: this.selectVal.youthUuid,
          organUuid: this.selectVal.organUuid,
          squadUuid: this.selectVal.squadUuid,
          squadId: this.selectVal.squadId,
          squadName: this.squadName
        }
      })
      this.getTeachingList()
    },
    changeOrg () {
      this.centerList = []
      this.$set(this.selectVal, 'youthUuid', '')
      this.squadList = []
      this.squadName = ''
      this.$set(this.selectVal, 'squadUuid', '')
      this.$set(this.selectVal, 'squadId', '')
      if (this.selectVal.organUuid) {
        const { youthList } = this.organList.find(item => {
          return item.organUuid === this.selectVal.organUuid
        })
        this.centerList = youthList || []
        if (this.centerList.length === 1) {
          this.$set(this.selectVal, 'youthUuid', this.centerList[0].uuid)
          const { squadList } = this.centerList.find(item => {
            return item.uuid === this.selectVal.youthUuid
          })
          this.squadList = squadList || []
          if (this.squadList.length === 1) {
            this.$set(this.selectVal, 'squadUuid', this.squadList[0].uuid)
            this.$set(this.selectVal, 'squadId', this.squadList[0].id)
            this.squadName = this.squadList[0].shortName
          }
        }
      }
      this.changeQuery(true)
    },
    changeCenter () {
      this.squadList = []
      this.$set(this.selectVal, 'squadUuid', '')
      this.$set(this.selectVal, 'squadId', '')
      if (this.selectVal.youthUuid) {
        const { squadList } = this.centerList.find(item => {
          return item.uuid === this.selectVal.youthUuid
        })
        this.squadList = squadList || []
        if (this.squadList.length === 1) {
          this.$set(this.selectVal, 'squadUuid', this.squadList[0].uuid)
          this.$set(this.selectVal, 'squadId', this.squadList[0].id)
          this.squadName = this.squadList[0].shortName
        }
      }
    },
    addPlan () {
      this.$router.push({
        path: 'addMatchPlan',
        query: {
          uuid: this.selectVal.squadId,
          squadName: this.squadName
        }
      })
    },
  }
}
</script>

<style scoped lang="stylus">
  @import '~@/assets/css/variable'
  .teachTitleList
    .active
      background-color #4cd964
  .mainTeachingContent
    height 480px
    margin-top 40px
    .list_wrap
      height:100%
      flex 1
      overflow hidden
      .table {
        display flex
        flex-direction column
        flex 1
        width: 100%;
        // margin: 30px 0 0;
        .thead {
          margin: 0 40px;
          border: 1px solid white
          border-bottom none
          .tr {
            height: 45px;
            display: flex;
          }
        }
        .scrollArea {
          height: 425px;
        }
        .tbodyWrap {
          display block
          // padding: 0 40px;
        }
        .tbody {
          display block
          width 810px
          margin-left auto
          margin-right auto
          max-width: 810px;
          border-top: none;
          border-bottom: none;
          .t_content{

            margin-bottom 30px
            .tr {
              height: 49px;
              display: flex;
              border: 1px solid $color_white;
              border-bottom none
              &:first{
                border-top none
              }
            }
            .bottom{
              cursor pointer
              border 1px solid white
              height 120px
              &:hover{
                background: url('~@/assets/images/common/hover_yioks.png') no-repeat right bottom;
                color: #4cd964;
                box-shadow: inset  0 0 12px #4cd964;
                border: 2px solid #4cd964
              }
              .intro{
                display flex
                justify-content center
                align-items center
                .team{
                  font-size 22px
                  display flex
                  align-items center
                  margin-top 10px
                  .teamName{
                    max-width 250px
                    text-overflow ellipsis
                    white-space normal
                    overflow hidden
                  }
                  .teamPlace{
                    margin 0 10px
                  }
                }
                .compete {
                  font-size 45px
                  margin 0 15px
                }
              }
             .matchType{
                display flex
                padding-bottom 10px
                justify-content center
                align-items center
               .left_triangle{
                 border-top 30px solid  #ff2d55
                 border-left  30px solid  transparent
               }
               .left{
                 display inline-block
                 height 30px
                 padding 0 15px
                 line-height 30px
                 background-color #ff2d55
                 color white
               }
               .right{
                 margin-left 20px
                 display inline-block
                 height 30px
                 padding 0 15px
                 line-height 30px
                 background-color $green_color
                 color white
               }
               .right_triangle{
                 border-top 30px solid  $green_color
                 border-right   30px solid  transparent
               }
             }
            }
          }
        }
        .th, .td {
          height: 100%;
          /*flex: 1 1 auto;*/
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: $font_size_medium;
          border-right: 1px solid $color_white;
        }
        .th:last-child, .td:last-child {
          border-right: none;
        }
        .td {
          p {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: $color_white;
          }
        }
        .org{
          width 20%
        }
        .name, .youth{
          width 17.5%
        }
        .coachName{
          width: 13%;
        }
        .start{
          width: 12%
        }
        .amount,.intensity{
          width: 12.5%;
        }

        .opt{
          width: 20%;
          p{
            width 100%
            text-align center
            .item{
              cursor: pointer;
              user-select: none;
              color $green_color
            }
            .split{
              margin 0 5px
            }
          }
        }
      }
</style>
